import {deleteRequest, getRequest, postRequest, putRequest} from "@/api/http";

// 获取图形验证码
export const getSmsCodeImg = (smsPhone) => getRequest("/smsAuth/sendAuthCode/" + smsPhone);

// 获取图形验证码
export const getCodeImg = () => getRequest("/captchaImage");
// 登录
export const loginAccount = (data) => postRequest("/loginForDoc", data);
export const login = (data) => postRequest("/loginWithSmsCode", data);
export const updateUserPwd = (data) => putRequest("/system/user/profile/updatePwd", data);
// 用户密码重置
// 获取用户详细信息
export const getUserInfo = (data) => getRequest("/getInfo", data);

// 公共模块
export const getDicts = (dictType) => getRequest("/system/dict/data/type/" + dictType);// 根据字典类型查询字典数据信息

// 预约管理
export const getReservationList = (data) => getRequest("/buz/patientReservation/list", data);
export const getCallNumberList = (data) => getRequest("/buz/patientReservation/listForDoc", data); // 叫号问诊查询
export const getQuickPanelData = (data) => getRequest("/buz/patientReservation/quickPanelData", data); // 叫号快捷面板查询
export const docCallNumber = (name) => putRequest("/buz/patientReservation/callPatient/"+name); // 叫号
export const docCallAccptNumber = (reId) => putRequest("/buz/patientReservation/callOrder/"+reId); // 接诊

// 病例管理/订单管理
export const listMedicalOrder = (data) => getRequest("/buz/medicalOrder/listForMyDoctorClinic", data); // 查询工单信息列表
export const listPatientHisMedical = (data) => getRequest("/buz/medicalOrder/listForClinicPatient", data); // 查询历史订单列表
export const getMedicalOrderDetailForOneMore = (orderId) => getRequest("/buz/medicalOrder/detailForOneMore/" + orderId); // 查询工单信息（再来一单） 包含所有信息
export const getMedicalOrderDetail = (orderId) => getRequest("/buz/medicalOrder/detail/" + orderId); // 查询工单信息详细 包含所有信息
export const getMedicalOrderId = (recordId) => getRequest("/buz/medicalOrder/getOrderId/" + recordId); // 通过病历ID获取orderId
export const getPatientListByName = (data) => getRequest("/buz/docPatientProfile/listAll", data);
export const getPatientList = (data) => getRequest("/buz/docPatientProfile/list", data);
export const getDocPatientProfile = (dppId) => getRequest("/buz/docPatientProfile/" + dppId); // 查询患者档案详细
export const saveDocPatientProfile = (data) => putRequest("/buz/docPatientProfile/saveInfo", data); // 新增或更新患者档案
export const addDocPatientProfile = (data) => postRequest("/buz/docPatientProfile", data); // 新增患者档案
export const updateDocPatientProfile = (data) => putRequest("/buz/docPatientProfile", data); // 修改患者档案
export const cancelOrder = (orderId) => getRequest("/buz/medicalOrder/cancelOrder/" + orderId);// 患者取消订单
export const addFromDocClinic = (data) => postRequest("/buz/medicalOrder/addFromDocClinic", data); // 新增订单药方
export const updateMedicalOrderForDoc = (data) => putRequest("/buz/medicalOrder/updateMedicalOrderForDoc", data); // 医生端修改工单信息

export const clinicSqbOrderPay = (data) => postRequest("/sqbOrderPay/create", data); // 收钱吧付款码收款


// 查询门诊导入临时病例列表
export const getCasePatientList = (data) => getRequest("/buz/case/list", data);

// 病历管理
export const listMedicalRecordOld = (data) => getRequest("/buz/medicalRecord/list", data); // 查询病历列表
export const listForClinicPatient = (data) => getRequest("/buz/medicalOrder/listForClinicPatient", data); // 查询病历列表
export const addMedicalRecord = (data) => postRequest("/buz/medicalRecord", data); // 新增患者病历
export const updateMedicalRecord = (data) => putRequest("/buz/medicalRecord/", data); // 修改患者病历

// 医生信息查询
export const getDoctorInfoByUserId = (userId, data) => getRequest("/buz/doctorInfo/getDoctorInfoByUserId/" + userId, data);// 根据userId查询医生信息详细
export const getDoctorInfo = (doctorId) => getRequest("/buz/doctorInfo/" + doctorId); // 根据doctorId查询医生信息详细
export const updateDoctorInfo = (data) => putRequest("/buz/doctorInfo", data);// 修改医生信息


// 辅料查询
export const listFuMedicine = (data) => getRequest("/buz/medicine/listFu", data);// 分类查询药品
export const listPharmacyConfig = (data) => getRequest("/buz/pharmacyConfig/list", data);// 查询配置信息

// 药品管理
export const listMedicineDecoction = (dictType, data) => getRequest("/system/dict/data/type/" + dictType, data);// 分类查询药品
export const listMedicine = (data) => getRequest("/buz/medicine/listForSelect", data);// 查询药品

// 门诊科室
export const getOutpatientServiceList = (data) => getRequest("/buz/outpatient/list", data);// 获取门诊列表

// 处方模版管理
export const listPrescription = (data) => getRequest("/buz/prescription/list", data); // 查询常用处方列表
export const getPrescriptionDetail = (preId, data) => getRequest("/buz/prescription/" + preId, data); // 查询常用处方详细
export const addPrescription = (data) => postRequest("/buz/prescription", data); // 新增常用处方
export const updatePrescription = (data) => putRequest("/buz/prescription", data); // 修改常用处方
export const delPrescription = (preId) => deleteRequest("/buz/prescription/"+preId); // 删除常用处方


// 统计分析
export const getColumnData = (startTime,endTime,data) => getRequest("/buz/docStat/getColumnData/" + startTime+"/"+endTime, data);
export const getServerData = (startTime,endTime, data) => getRequest("/buz/docStat/getServerData/" + startTime+"/"+endTime, data);


// 查询检查治疗项目配置列表
export const getTreatItemList = (data) => getRequest("/buz/treatItem/list", data);
// 查询检查治疗订单列表
export const getTreatOrderList = (data) => getRequest("/buz/treatOrder/list", data);
// 查询检查治疗订单所有列表
export const getTreatOrderAllList = (data) => getRequest("/buz/treatOrder/listAll", data);
// 查询检查治疗订单列表_子列表
export const getTreatOrderItemList = (data) => getRequest("/buz/treatOrderItem/list", data);
// 新增检查治疗订单
export const addNewTreatOrder = (data) => postRequest("/buz/treatOrder", data);

// 执行检查治疗项目
export const executetreatOrderItem = (toId) => putRequest("/buz/treatOrderItem/executeItem/" + toId); // 查询常用处方详细

